import api from '../axios/axios';

export const getContractType = (id: string) => {
  return api.get(`/contract-types/${id}`);
};

export const getContractTypes = () => {
  return api.get('/contract-types');
};

export const getNegotiatingContractType = (id: string) => {
  return api.get(`/contract-types/negotiation/${id}`);
};

export const createContract = (negotiationId: string) => {
  return api.post(`/contract`, { negotiationId });
};

export const getContractByNegotiationId = (id: string) => {
  return api.get(`/contract/negotiationId/${id}`);
};

export const signContract = (data: {
  contractId: string;
  lightSignature: string;
  darkSignature: string;
  name: string;
}) => {
  return api.post('/contract/sign', data);
};

export const getContractsByStatus = (
  limit: number,
  offset: number,
  status: string
) => {
  return api.get(`/contract?limit=${limit}&offset=${offset}&status=${status}`);
};

export const getContractsByStatusNoLimit = (status: string) => {
  return api.get(`/contract?status=${status}`);
};

export const getContractsCountByStatus = (status: string) => {
  return api.get(`/contract/count/${status}`);
};

export const getContractPDF = (negotiationId: string) => {
  return api.get(`/contract/getPdfbyNegotiationId/${negotiationId}`);
};

export const getContractDocx = (negotiationId: string) => {
  return api.get(`/contract/getDocxbyNegotiationId/${negotiationId}`);
};

export const approveContract = (id: string) => {
  return api.put(`/contract/${id}/approve`);
};
export const getUserUnfinishedContracts = (limit: number, offset: number) => {
  return api.get(
    `/contract/need-current-user-response?limit=${limit}&offset=${offset}`
  );
};

export const getUserUnfinishedContractsCount = () => {
  return api.get(`/contract/need-current-user-response/count`);
};
export const getOtherPartyUnfinishedContracts = (
  limit: number,
  offset: number
) => {
  return api.get(
    `/contract/need-other-response?limit=${limit}&offset=${offset}`
  );
};

export const getOtherPartyUnfinishedContractsCount = () => {
  return api.get(`/contract/need-other-response/count`);
};

export const getOtherPartyUnfinishedNegotiationsNoLimit = () => {
  return api.get(`/contract/need-other-response`);
};

export const getAllContractsCount = () => {
  return api.get(`/contract/all-contracts/count`);
};

export const getAllContracts = (limit: number, offset: number) => {
  return api.get(`/contract/all-contracts?limit=${limit}&offset=${offset}`);
};

export const getAllContractsFiltered = (filters: any) => {
  return api.get(`/contract/all-contracts`, {
    params: filters
  });
};

export const getUserUnfinishedNegotiationsCount = () => {
  return api.get(`/contract/need-current-user-response/count`);
};

export const getOtherPartyUnfinishedNegotiationsCount = () => {
  return api.get(`/contract/need-other-response/count`);
};

export const archiveContract = (id: string) => {
  return api.put(`/contract/${id}/archive`);
};
